export default __webpack_public_path__ + "static/media/illustration_01.d6bb27b4.svg";